import React, { useState, useEffect } from 'react';
import DropDown from '../../../../../components/DropDown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCommentDots,
  faFileCircleCheck,
  faGear,
  faPrint,
  faQuestionCircle
} from '@fortawesome/free-solid-svg-icons';
import RCDropdown from 'rc-dropdown';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownMenu from 'react-bootstrap/esm/DropdownMenu';
import DropdownItem from 'react-bootstrap/esm/DropdownItem';
import Menu, { Item as MenuItem } from 'rc-menu';
import 'rc-dropdown/assets/index.css';
import PropTypes from 'prop-types';
import CustomToast from '../../../../../components/Toast';
import appConfig from '../../../../../app-config';
import { useSelector } from 'react-redux';
import { selectCurrentToken } from '../../../../../features/authentication/authSlice';
import { useNavigate } from 'react-router-dom';

const StandardPrintingHeader = ({
  updateSettings,
  fontSizeValue,
  fontStyleValue,
  mcSpaceValue,
  mcstyleValue,
  answerKeyValue,
  assignmentName,
  assignmentId
}) => {
  const [selectedFontStyle, setSelectedFontStyle] = useState();
  const [selectedFontSize, setSelectedFontSize] = useState();
  const [selectedMCSpacing, setSelectedMCSpacing] = useState();
  const [selectedMCStyle, setSelectedMCStyle] = useState();
  const [selectedAnswerKey, setSelectedAnswerKey] = useState();
  const [visible, setVisible] = useState(false);
  const baseUrl = appConfig.apiBaseUrl;
  const accessToken = useSelector(selectCurrentToken);
  const [isPdfGenerating, setIsPdfGenerating] = React.useState(false);
  const navigate = useNavigate();

  const fontStyle = [
    {
      id: 'Times New Roman',
      name: 'Default'
    },
    {
      id: 'arial',
      name: 'Arial'
    },
    {
      id: 'comic Sans MS',
      name: 'Comic Sans'
    },
    {
      id: 'Courier',
      name: 'Courier'
    },
    {
      id: 'Tahoma',
      name: 'Tahoma'
    },
    {
      id: 'Times New Roman',
      name: 'Times New Roman'
    },
    {
      id: 'Verdana',
      name: 'Verdana'
    }
  ];

  const fontSize = [
    {
      id: 10,
      name: '10 pt'
    },
    {
      id: 12,
      name: '12 pt'
    },
    {
      id: 14,
      name: '14 pt'
    },
    {
      id: 16,
      name: '16 pt'
    },
    {
      id: 20,
      name: '20 pt'
    },
    {
      id: 24,
      name: '24 pt'
    }
  ];

  const mcSpacing = [
    {
      id: 1,
      name: 'Single'
    },
    {
      id: 15,
      name: '1.5'
    },
    {
      id: 2,
      name: 'Double'
    }
  ];

  const mcStyle = [
    {
      id: 0,
      name: '1 2 3'
    },
    {
      id: 1,
      name: 'a b c'
    },
    {
      id: 2,
      name: 'A B C'
    },
    {
      id: 3,
      name: '1. 2. 3.'
    },
    {
      id: 4,
      name: 'a. b. c.'
    },
    {
      id: 5,
      name: 'A. B. C.'
    },
    {
      id: 6,
      name: '(A) (B) (C)'
    }
  ];

  const answerKey = [
    {
      id: 0,
      name: 'None'
    },
    {
      id: 1,
      name: 'Compact'
    },
    {
      id: 2,
      name: 'Single Line'
    }
  ];

  const answerOptions = [
    {
      id: 'display',
      name: 'Display Answers',
      checkbox: true
    },
    {
      id: 'cr',
      name: 'CR Answer Space',
      checkbox: true
    },
    {
      id: 'mc',
      name: 'MC Answer Space',
      checkbox: true
    },
    {
      id: 'fill',
      name: 'Fill-in Answer Space',
      checkbox: true
    },
    {
      id: 'remove',
      name: 'Remove All Answer Space',
      checkbox: false
    }
  ];

  const formatOptions = [
    {
      id: 0,
      name: 'Stack All Questions (2 Column)'
    },
    {
      id: 1,
      name: 'Clear Current Session Changes'
    },
    {
      id: 2,
      name: 'Reset All'
    }
  ];

  const handleFontStyle = (event) => {
    const selectedFont = event.target.value;
    setSelectedFontStyle(selectedFont);
    updateSettings({ fontStyleData: selectedFont });
    CustomToast('Font Style/Size Changed', 'info');
  };

  const handleFontSize = (event) => {
    const selectedFont = parseInt(event.target.value);
    setSelectedFontSize(selectedFont);
    updateSettings({ fontSizeData: selectedFont });
    CustomToast('Font Style/Size Changed', 'info');
  };

  const handleMCSpacing = (event) => {
    const selectedSpacing = parseInt(event.target.value);
    setSelectedMCSpacing(selectedSpacing);
    updateSettings({ mcSpacingData: selectedSpacing });
    CustomToast('MC Spacing Changed', 'info');
  };

  const handleMCStyle = (event) => {
    const selectedStyle = parseInt(event.target.value);
    setSelectedMCStyle(selectedStyle);
    updateSettings({ mcStylingData: selectedStyle });
    CustomToast('MC Style Changed', 'info');
  };

  const handleAnswerKey = (event) => {
    const selectedAnswer = parseInt(event.target.value);
    setSelectedAnswerKey(selectedAnswer);
    updateSettings({ answerKey: selectedAnswer });
    CustomToast('Answer Key Changed', 'info');
  };

  const handleBackButtonClick = () => {
    navigate(-1);
  };

  const handleChange = (e) => {
    console.log(e.target.value);
  };

  const menu = (
    <Menu style={{ width: '100%' }} multiple onSelect={handleChange} onDeselect={handleChange}>
      {answerOptions.map((item, index) => (
        <MenuItem key={item.id}>
          {item.checkbox && (
            <div className="form-check">
              <input
                key={`name${item.id}`}
                type="checkbox"
                className="form-check-input"
                checked={item.isChecked}
                name={'check-' + index}
                id={'check-' + index + item.id}
                disabled
              />
              <div className="mb-0">
                <div htmlFor={'check-' + index}>{item.name}</div>
              </div>
            </div>
          )}
          {!item.checkbox && <div>{item.name}</div>}
        </MenuItem>
      ))}
    </Menu>
  );

  const handleVisibleChange = (visible) => {
    setVisible(visible);
  };

  const initialData = () => {
    setSelectedFontSize(fontSizeValue);
    setSelectedFontStyle(fontStyleValue);
    setSelectedMCSpacing(mcSpaceValue);
    setSelectedMCStyle(mcstyleValue);
    setSelectedAnswerKey(answerKeyValue);
  };

  const handlePrintPDF = async () => {
    setIsPdfGenerating(true);

    const contentWrapper = document.getElementById('print-assignment-questions');
    const contentClone = contentWrapper.cloneNode(true);
    const base64Encoded = btoa(contentClone.innerHTML);

    fetch(`${baseUrl}/PdfGenerator`, {
      method: 'POST',
      body: JSON.stringify({
        htmlContent: base64Encoded,
        OutputFileName: 'StandardAssignmentPrint',
        PageSize: 3
      }),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      },
      mode: 'cors',
      credentials: 'include'
    })
      .then((response) => response.blob())
      .then((blob) => {
        if (blob.type === 'application/pdf') {
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          const fileName = `${assignmentName}_${assignmentId}.pdf`;
          link.download = fileName;
          link.href = url;
          link.click();
          URL.revokeObjectURL(url);
        } else {
          CustomToast('Error ocuurred while generating pdf.', 'error');
        }
        setIsPdfGenerating(false);
      })
      .catch((error) => {
        console.error(error);
        setIsPdfGenerating(false);
      });
  };

  useEffect(() => {
    initialData();
  }, [fontSizeValue, fontStyleValue, mcSpaceValue, mcstyleValue, answerKeyValue]);

  return (
    <div className="print-header mb-4">
      <div className="d-flex gap-3 print-header-content">
        <div className="col">
          <DropDown
            label="Font Style"
            value={fontStyle}
            onChangeHandler={handleFontStyle}
            selectedValue={selectedFontStyle}
          />
        </div>
        <div className="col">
          <DropDown
            label="Font Size"
            value={fontSize}
            onChangeHandler={handleFontSize}
            selectedValue={selectedFontSize}
          />
        </div>
        <div className="col">
          <DropDown
            label="MC Spacing"
            value={mcSpacing}
            onChangeHandler={handleMCSpacing}
            selectedValue={selectedMCSpacing}
          />
        </div>
        <div className="col">
          <DropDown
            label="MC Style"
            value={mcStyle}
            onChangeHandler={handleMCStyle}
            selectedValue={selectedMCStyle}
          />
        </div>
        <div className="col">
          <DropDown
            label="Answer Key"
            value={answerKey}
            onChangeHandler={handleAnswerKey}
            selectedValue={selectedAnswerKey}
          />
        </div>
        <div
          className="form-control print-header-select answer-option col disable-Pointer-Events"
          id="anwerOptions">
          <RCDropdown
            trigger={['click']}
            onVisibleChange={handleVisibleChange}
            visible={visible}
            closeOnSelect={false}
            overlay={menu}
            animation="slide-up"
            getPopupContainer={() => document.getElementById('anwerOptions')}>
            <div className="d-flex align-items-center">
              <FontAwesomeIcon icon={faFileCircleCheck} className="print-select-icon " />
              <span className="d-flex">Answer Options</span>
            </div>
          </RCDropdown>
        </div>
        <div className="form-control print-header-select format-option col disable-Pointer-Events">
          <Dropdown>
            <Dropdown.Toggle>
              <div className="d-flex align-items-center">
                <FontAwesomeIcon icon={faGear} className="print-select-icon" />
                <span className="d-flex">Format Options</span>
              </div>
            </Dropdown.Toggle>
            <DropdownMenu className="">
              {formatOptions.map((item) => (
                <DropdownItem key={item.id}>{item.name}</DropdownItem>
              ))}
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
      <div className="button-container d-flex align-items-center justify-content-between">
        <div className="d-flex gap-4 btn-link flex-wrap">
          <div className="d-flex gap-1 align-items-center flex-shrink-0">
            <FontAwesomeIcon icon={faQuestionCircle} />
            <span>FAQ & Tips</span>
          </div>
          <div className="d-flex gap-1 align-items-center flex-shrink-0">
            <FontAwesomeIcon icon={faCommentDots} />
            <span>Feedback</span>
          </div>
        </div>
        <div className="d-flex gap-2 flex-wrap">
          <button className="btn-classicPrint d-flex align-items-center gap-1 flex-shrink-0">
            <FontAwesomeIcon icon={faPrint} />
            <span>Classic Print</span>
          </button>
          <button className="btn btn-castleWhite" onClick={handleBackButtonClick}>
            Back
          </button>
          <button className="btn btn-castleWhite" disabled>
            View Student PDF
          </button>
          <button className="btn btn-studentPDF" disabled>
            Create Student PDF
          </button>
          <button className={`btn btn-castleRed ${isPdfGenerating?"disabled":""}`} onClick={handlePrintPDF}>
            {isPdfGenerating ? 'Generating PDF...' : 'Print to PDF'}
          </button>
        </div>
      </div>
    </div>
  );
};

StandardPrintingHeader.propTypes = {
  fontSizeValue: PropTypes.number,
  fontStyleValue: PropTypes.string,
  mcSpaceValue: PropTypes.number,
  mcstyleValue: PropTypes.number,
  answerKeyValue: PropTypes.number,
  updateSettings: PropTypes.func,
  assignmentName: PropTypes.string,
  assignmentId: PropTypes.number
};

export default StandardPrintingHeader;
